<template>
  <div class="c-learning">
    <div class="c-learning__header">
      学习效果
      <ul class="subject">
        <li v-for="(item,index) in subjectList"
        @click="clickSubject(item)"
        :key="index" :class="['subject__item',
        item.id===activeId?active:''
        ]">{{item.name}}</li>
      </ul>
    </div>
    <div class="c-learning__bgc" >
      <div class="learning-effect" ></div>
      <EmptyLearning v-if="show"/>
    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts';
import EmptyLearning from './empty-learning.vue';

export default {
  name: 'LearningEffect',
  components: { EmptyLearning },
  props: {
    masteryDegree: {
      require: true,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
      subjectList: [
        { name: '英语', id: 1 },
        { name: '数学', id: 2 },
        { name: '语文', id: 3 },
        { name: '物理', id: 4 },
        { name: '化学', id: 5 },
        { name: '生物', id: 6 },
        { name: '地理', id: 7 },
        { name: '科学', id: 8 },
      ],
      activeId: 2,
      showList: [],
    };
  },
  mounted() {

  },
  watch: {
    masteryDegree() {
      this.showList = this.masteryDegree[0].degree_info;
      this.initCharts();
    },
    activeId() {
      this.initCharts();
    },
  },
  computed: {
    active() {
      return `active_${this.activeId}`;
    },
  },
  methods: {
    initCharts() {
      // 基于准备好的dom，初始化echarts实例
      const list = this.masteryDegree.filter((item) => item.subject_id === this.activeId)[0]
        .degree_info;
      this.show = (list || []).length === 0; // 如果没有数据，显示空页面
      const myChart = echarts.init(document.querySelector('.learning-effect'));
      // 绘制图表
      myChart.setOption({
        title: {
          text: '知识点掌握程度',
          top: 25,
          left: 31,
          textStyle: {
            fontSize: 16,
            color: '#FFFFFF',
            fontWeight: 500,
          },
        },
        grid: {
          top: 90,
        },
        legend: {
          show: true,
          top: 25,
          right: 80,
          icon: 'circle',
          textStyle: {
            fontSize: '14',
            color: '#fff',
          },
          data: ['学前', '学后'],
        },
        tooltip: {},
        xAxis: {
          type: 'category',
          axisTick: {
            show: false,
          },
          data: list.map((item) => item.grade_name),
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: '16',
            },
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: ['rgba(255, 255, 255, 0.3)'],
            },
          },
          axisLabel: {
            formatter(value) {
              return `${Math.floor(value * 100)}%`;
            },
            textStyle: {
              color: '#fff',
              fontSize: '16',
            },
          },
        },
        series: [
          {
            name: '学前',
            type: 'bar',
            barMaxWidth: 24,
            data: list.map((item) => item.pre_ability),
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#FDA76F',
                }, {
                  offset: 1,
                  color: '#FF7442',
                }]),
                label: {
                  formatter(params) {
                    return `${Math.floor(params.data * 100)}%`;
                  },
                  show: true,
                  position: 'top',
                  textStyle: {
                    fontWeight: 500,
                    fontSize: '14',
                    color: '#fff',
                  },

                },
              },
            },
          },
          {
            name: '学后',
            type: 'bar',
            barMaxWidth: 24,
            data: list.map((item) => item.final_ability),
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#14BFFF',
                }, {
                  offset: 1,
                  color: '#1097FF',
                }]),
                label: {
                  formatter(params) {
                    return `${Math.floor(params.data * 100)}%`;
                  },
                  show: true,
                  position: 'top',
                  textStyle: {
                    fontWeight: 500,
                    fontSize: '14',
                    color: '#fff',
                  },

                },
              },
            },
          },
        ],
      });
    },
    clickSubject(item) {
      this.activeId = item.id;
      this.showList = this.masteryDegree.filter((i) => i.subject_id === this.activeId)[0]
        .degree_info;
    },
  },

};
</script>

<style lang="scss" scoped>
.c-learning{
  padding: 26px 40px 0 40px;
  width: 1062px;
  height: 686px;
  box-sizing: border-box;
  background: url('../../images/study_effect_bg.png') no-repeat;
  background-size: contain;
  &__header {
    display: flex;
    justify-content: space-between;
    position: relative;
    font-size: 28px;
    font-weight: 500;
    text-indent: 1em;
    color: #E3E2FF;
    margin-left:33px ;
  &::before {
    content: '';
    position: absolute;
    width: 27px;
    height: 27px;
    top: 9px;
    left: -33px;
    background: url('../../images/cockpit-icon.png') no-repeat center / contain;
}
  .subject{
    display: flex;
    // background: url('../../images/subject_tab.png') no-repeat;
    // background-size:300px 42px ;
    &__item{
      width: 100px;
      height: 42px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #E0EFFF;
      line-height: 42px;
    }
    .active_1{
      background:
      linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
      border-radius: 11px 0px 0px 11px;
    }
    .active_2{
      background:
      linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
    }
    .active_3{
      background:
      linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
    }
    .active_4{
      background:
      linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
    }
    .active_5{
      background:
      linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
    }
    .active_6{
      background:
      linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
    }
    .active_7{
      background:
      linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
    }
    .active_8{
      background:
      linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
      border-radius: 0px 11px 11px 0px;
    }
  }
  }
  &__bgc{
    margin-top:30px ;
    position: relative;
    width: 982px;
    height: 552px;
    background: linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
    border-radius: 8px ;
    // opacity: 0.38;
    }

  .learning-effect{
      position: absolute;
      top: 0;
      left: 0;
      width: 970px;
      height: 500px;
    }
}
</style>
